import React from 'react'
import { Link } from 'gatsby'
import { Button } from 'react-bootstrap'

const IconBlocks = props => {
  return (
    
    <section className="g-py-100">
    <div className="container">
      <div className="row no-gutters">
        <div className="col-lg-4 g-px-40 g-mb-50 g-mb-0--lg" data-sal="slide-up" data-sal-delay="200">
          {/* Icon Blocks */}
          <div className="text-center">
            <span className="d-inline-block u-icon-v3 u-icon-size--xl g-bg-primary g-color-white rounded-circle g-mb-30">
                <i className="icon-communication-001 u-line-icon-pro"></i>
              </span>
            <h3 className="h5 g-color-gray-dark-v2 g-font-weight-600 text-uppercase mb-3">
              Connection
            </h3>
            <p className="mb-0">
              Ours is a global alliance of hemp producers, processors, engineers, designers, inventors, investors and customers. Plug into our network of ideas, innovations and opportunity.
            </p>
            <p className="mb-0" style={{marginTop: "20px"}}>
              <Link to="/services"><Button>Learn More</Button></Link>
            </p>
          </div>
          {/* End Icon Blocks */}
        </div>

        <div className="col-lg-4 g-brd-left--lg g-brd-gray-light-v4 g-px-40 g-mb-50 g-mb-0--lg" data-sal="slide-up" data-sal-delay="400">
          {/* Icon Blocks */}
          <div className="text-center">
            <span className="d-inline-block u-icon-v3 u-icon-size--xl g-bg-primary g-color-white rounded-circle g-mb-30">
                <i className="icon-education-200 u-line-icon-pro"></i>
              </span>
            <h3 className="h5 g-color-gray-dark-v2 g-font-weight-600 text-uppercase mb-3">
              Expertise
            </h3>
            <p className="mb-0">
              Seeking Hemp 101? Need a virtual “PhD” in the subject? Or are you the expert our members need to know? Steel sharpens steel; and hemp knowledge begets hemp success.
            </p> 
            <p className="mb-0" style={{marginTop: "20px"}}>
              <Link to="/services"><Button>Learn More</Button></Link>
            </p>
          </div>
          {/* End Icon Blocks */}
        </div>

        <div className="col-lg-4 g-brd-left--lg g-brd-gray-light-v4 g-px-40" data-sal="slide-up" data-sal-delay="600">
          {/* Icon Blocks */}
          <div className="text-center">
            <span className="d-inline-block u-icon-v3 u-icon-size--xl g-bg-primary g-color-white rounded-circle g-mb-30">
                <i className="icon-science-142 u-line-icon-pro"></i>
              </span>
            <h3 className="h5 g-color-gray-dark-v2 g-font-weight-600 text-uppercase mb-3">Innovation</h3>
            <p className="mb-0">
              What if this exciting new industry could apply big, audacious ideas from other sectors? And compete globally? It can, and we’re leading the way for every link in the hemp supply chain.
            </p>
            <p className="mb-0" style={{marginTop: "20px"}}>
              <Link to="/technology"><Button>Learn More</Button></Link>
            </p>
          </div>
          {/* End Icon Blocks */}
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default IconBlocks
